import Config from 'Config';
import aws4 from 'aws4';

export default async function setProjectFormVisibilityControl(data, params) {
  const { projectId, ...payload } = data;
  const apiPath = `projects/${projectId}/form-visibility-control`;

  const request = {
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  };

  const signer = new aws4.RequestSigner(request, {
    accessKeyId: params.accessKeyId,
    secretAccessKey: params.secretAccessKey,
    sessionToken: params.sessionToken,
  });

  const signedRequest = signer.sign();
  signedRequest.headers.Accept = '*/*';

  return fetch(
    `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // `http://localhost:3001/${apiPath}`,
    signedRequest
  ).then((res) => res.json());
}
